import { useCartDispatch } from '@/contexts/CartContext'
import { LoginSchema, LoginValues } from '@/forms/Login'
import useAuth from '@/hooks/useAuth'
import cart from 'cart'
import { Form, Formik, FormikHelpers } from 'formik'
import { Dispatch, SetStateAction } from 'react'
import { VerificationData } from '@/types'
import SubmitButton from '../forms/SubmitButton'
import TextInput from '../forms/TextInput'

interface Props {
  setIsLoginOpen: Dispatch<SetStateAction<boolean>>
  setVerificationError: Dispatch<SetStateAction<boolean>>
  setVerificationData: Dispatch<SetStateAction<undefined | VerificationData>>
  setIsForgotOpen: Dispatch<SetStateAction<boolean>>
}
export default function Login({
  setIsLoginOpen,
  setVerificationError,
  setVerificationData,
  setIsForgotOpen,
}: Props) {
  const cartDispatch = useCartDispatch()
  const { login, isLoading } = useAuth('none')
  const handleSubmit = (
    values: LoginValues,
    actions: FormikHelpers<LoginValues>,
  ) => {
    login(
      values.identifier,
      values.password,
      actions.setFieldError,
      setIsLoginOpen,
      setVerificationError,
      setVerificationData,
      cartDispatch
    )
  }
  return (
    <Formik
      initialValues={{
        identifier: '',
        password: '',
      }}
      validateOnChange={false}
      validateOnBlur={false}
      validationSchema={LoginSchema}
      onSubmit={handleSubmit}>
      {({ errors, touched }) => (
        <Form>
          <div className="form">
            <div className="form-group flex flex-col">
              <TextInput
                label={'الهاتف او البريد الالكتروني'}
                type="text"
                name="identifier"
                placeholder={'أدخل رقم الهاتف او البريد الالكتروني'}
                dir="ltr"
                isError={errors.identifier && touched.identifier}
                error={errors.identifier}
              />
            </div>
            <div className="form-group flex flex-col mt-3">
              <div className="relative w-full">
                <TextInput
                  label={'كلمة مرور'}
                  type="password"
                  name="password"
                  placeholder={'ادخل رقمك السري'}
                  isError={errors.password && touched.password}
                  error={errors.password}
                />
              </div>
            </div>

            <div className="flex items-center justify-between mt-3">
              <div className="checkbox opacity-0 flex items-center">
                <input
                  type="checkbox"
                  name="checkbox"
                  className="rounded
                                    bg-white
                          border-primary-500
                          focus:border-transparent focus:bg-gray-200
                          ml-2
                          text-primary-500
                          focus:ring-1 focus:ring-gray-700"
                  id="checkbox"
                  value={'1'}
                />
                <label
                  htmlFor="checkbox"
                  className="text-xs border-primary font-bold ml-1">
                  تذكرني
                </label>
              </div>
              <a
                onClick={e => {
                  setIsLoginOpen(false);
                  e.preventDefault()
                  setIsForgotOpen(true)
                }}
                className="font-semibold underline text-sm cursor-pointer">
                نسيت كلمة السر؟
              </a>
            </div>
            <SubmitButton isLoading={isLoading} text={'تسجيل الدخول'} />
          </div>
        </Form>
      )}
    </Formik>
  )
}
